/**
 * AgentToggle — Switch between normal SkillBot and Agent mode
 * Shows only if AGENT_MODE is enabled on the backend
 */
import React from 'react';
import { Bot, Sparkles } from 'lucide-react';

const AgentToggle = ({ isAgentMode, onToggle, domainName, domainIcon, fullPage = false }) => {
  return (
    <button
      onClick={onToggle}
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
        isAgentMode
          ? 'bg-amber-400/30 text-white border border-amber-300/50'
          : 'bg-white/20 text-white/80 hover:bg-white/30 border border-transparent'
      }`}
      title={isAgentMode ? 'Switch to SkillBot mode' : 'Switch to Agent mode'}
    >
      {isAgentMode ? (
        <>
          <Bot className="w-3.5 h-3.5" />
          <span>{domainIcon || ''} Agent</span>
        </>
      ) : (
        <>
          <Sparkles className="w-3.5 h-3.5" />
          <span>Agent</span>
        </>
      )}
    </button>
  );
};

export default AgentToggle;
